import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { faDash } from '@fortawesome/pro-solid-svg-icons';

import { So5FixtureEvent } from '@sorare/core/src/__generated__/globalTypes';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { useScreenSize } from '@sorare/core/src/hooks/device/useScreenSize';

import { Grade } from 'components/player/Grade';
import { Cell } from 'components/searchPlayerTable/SearchTable/ui';

import type { ProjectionGradeCell_anyPlayer } from './__generated__/index.graphql';

type Props = {
  anyPlayer: ProjectionGradeCell_anyPlayer;
  so5FixtureEvent: So5FixtureEvent;
};

export const ProjectionGradeCell = ({ anyPlayer, so5FixtureEvent }: Props) => {
  const { up: laptopOrAbove } = useScreenSize('laptop');
  const projectedGrade = (() => {
    switch (so5FixtureEvent) {
      case So5FixtureEvent.DAILY:
        return anyPlayer.nextDailyFixtureProjectedGrade;

      case So5FixtureEvent.CLASSIC:
      default:
        return anyPlayer.nextClassicFixtureProjectedGrade;
    }
  })();

  return (
    <Cell>
      {projectedGrade === null ? (
        <FontAwesomeIcon icon={faDash} color="var(--c-nd-500)" />
      ) : (
        <Grade size={laptopOrAbove ? 4 : 3} projection={projectedGrade} />
      )}
    </Cell>
  );
};

ProjectionGradeCell.fragments = {
  anyPlayer: gql`
    fragment ProjectionGradeCell_anyPlayer on AnyPlayerInterface {
      slug
      nextDailyFixtureProjectedGrade {
        id
        ...Grade_playerGameScoreProjection
      }
      nextClassicFixtureProjectedGrade {
        id
        ...Grade_playerGameScoreProjection
      }
    }
    ${Grade.fragments.projection}
  ` as TypedDocumentNode<ProjectionGradeCell_anyPlayer>,
};
